import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SETUP_LAST_STEP, type OnboardingGoal } from '@alexiarest/shared';
import { useUpdateTenant } from '../api/hooks';
import { Card } from '../components/Card';
import { GoalChoices } from '../components/GoalChoices';
import { useToast } from '../components/Toast';

/** Existing accounts choose once; the saved account goal survives devices and logins. */
export function ChooseGoalPage(): JSX.Element {
  const [goal, setGoal] = useState<OnboardingGoal>();
  const update = useUpdateTenant();
  const toast = useToast();
  const navigate = useNavigate();
  return <main className="goal-welcome"><Card title="Vamos a por tu primer resultado" hint="Elige por dónde quieres empezar con Alexia.">
    <form className="stack" onSubmit={e => { e.preventDefault(); if (!goal) return;
      update.mutate({ onboardingGoal: goal, setup: { step: SETUP_LAST_STEP, completed: true } }, { onSuccess: () => navigate('/'), onError: toast.fail });
    }}><GoalChoices value={goal} onChange={setGoal} disabled={update.isPending} />
      <button className="btn" disabled={!goal || update.isPending}>{update.isPending ? 'Guardando…' : 'Empezar'}</button>
    </form>
  </Card></main>;
}
